import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';

import { BankIcon } from './components/BankIcon';
import * as styles from './styles.css';
import { PROMO_ICON } from '../../constants/promoIcon';
import { EPromoType, IPromoInfo } from '../../types/newbuilding/promoInfo';

interface IPromoItemProps {
  promo: IPromoInfo;
  onClick(): void;
}

export function PromoItem({ promo, onClick }: IPromoItemProps) {
  const { bank, promoType, name, subtitle } = promo;
  const icon = PROMO_ICON.get(promoType);

  return (
    <div className={styles['container']} onClick={onClick} data-testid="PromoItem">
      <div className={styles['icon']}>
        {promoType === EPromoType.Bank ? <BankIcon bank={bank} /> : <img src={icon} alt="" />}
      </div>
      <div>
        <div className={styles['title']}>
          <ArticleHeading4 as="h4">{name}</ArticleHeading4>
        </div>
        {subtitle && <ArticleParagraph2 color="gray60_100">{subtitle}</ArticleParagraph2>}
      </div>
    </div>
  );
}
